import React from 'react';
import PropTypes from 'prop-types';

import InternalLink from '../InternalLink';
import OutboundLink from '../OutboundLink';
import LinkContent from './components/LinkContent';

export default class Link extends React.Component {
  renderExternalLink() {
    const { to, title, linkAs, contentProps, ...rest } = this.props;

    return (
      <OutboundLink label={title} to={to} {...rest}>
        <LinkContent linkAs={linkAs} title={title} {...contentProps} />
      </OutboundLink>
    );
  }

  renderInternalLink() {
    const { to, title, linkAs, contentProps, ...rest } = this.props;

    return (
      <InternalLink to={to} label={title} {...rest}>
        <LinkContent linkAs={linkAs} title={title} {...contentProps} />
      </InternalLink>
    );
  }

  render() {
    const { internal } = this.props;

    return internal ? this.renderInternalLink() : this.renderExternalLink();
  }
}

Link.propTypes = {
  to: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  internal: PropTypes.bool,
  linkAs: PropTypes.string,
};

Link.defaultProps = {
  internal: true,
  linkAs: 'span',
};
